/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { useModalControls } from '@hooks';
import { Button } from '@atoms';

import CisBulkUnApproveEventModal from '../CisBulkUnApproveEventModal';

const CisBulkUnApprove = ({ type, uploadButtonText = 'BULK UNAPPROVE', ...props }) => {
  const modal = useModalControls();

  return (
    <>
      <Button type={type ?? 'customBlue'} {...props} onClick={modal.show}>
        {uploadButtonText}
      </Button>
      <CisBulkUnApproveEventModal {...modal} type="USERS" onSubmit={props?.onSubmit} />
    </>
  );
};

export default CisBulkUnApprove;
